var exports = {
  "az": "Box__WY-B-J",
  "wy": "Box_1__vQABwx",
  "m4": "Octicon__3A5pJr",
  "EY": "Text__6gsc7y",
  "pv": "Box_2__d47O4y",
  "bE": "editModeOn__jjP9in",
  "$Y": "editModeOff__KcpeQd",
  "UE": "Text_1__Je0s9Y",
  "$n": "Button__wgWvzw",
  "w9": "Box_3__1nREK_",
  "pQ": "Box_4__NSboXK",
};

module.exports = exports;
